import { buildFilterString } from '@/common/api/items';
import { tempoApi } from '@/common/api/tempoApi';
import type { ItemFiltersType } from '@/common/api/types/itemFilters';
import type { ItemTreeSet } from '@/common/api/types/items';
import { REPORTING_STORE_API_BASE } from './constants';

export const fetchReportingStoreItemsTreeSet = async ({
  filter,
  order,
  includeDescendants,
}: {
  filter?: ItemFiltersType;
  order?: string;
  includeDescendants?: boolean;
}): Promise<ItemTreeSet> => {
  const filterString = buildFilterString(filter);
  return await tempoApi()
    .post(`${REPORTING_STORE_API_BASE}/items/tree-set`, {
      json: { filter: filterString, order, includeDescendants },
    })
    .json<ItemTreeSet>();
};
